import { render, staticRenderFns } from "./costAnalysisComponent.vue?vue&type=template&id=81df117a&scoped=true"
import script from "./costAnalysisComponent.vue?vue&type=script&lang=js"
export * from "./costAnalysisComponent.vue?vue&type=script&lang=js"
import style0 from "./costAnalysisComponent.vue?vue&type=style&index=0&id=81df117a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df117a",
  null
  
)

export default component.exports